export const businessHours = {
    // days of week. an array of zero-based day of week integers (0=Sunday)
    daysOfWeek: [1, 2, 3, 4, 5 ], // Monday - firday
    startTime: '06:00', // a start time (10am in this example)
    endTime: '18:00', // an end time (6pm in this example)
  }

  export const timebuttons = [
    //{ key: 'dayGridMonth', text: 'Month' },
    { key: 'timeGridWeek', text: 'Week' },
    { key: 'timeGridDay', text: 'Day' },
    { key: 'listWeek', text: 'List' },
  ]